import _ from 'lodash';
import { ToastType } from 'Core-utils/types/ToastType';

type CanvasItemRef = { id: string };

export const shouldAutoAddResolutionDeadline = (
    droppedId: string,
    canvasItems: CanvasItemRef[],
    resolutionDeadlineId: string,
    resolutionExpiryActionId: string,
): boolean => droppedId === resolutionExpiryActionId && !canvasItems.some((item) => item.id === resolutionDeadlineId);

export const appendDroppedCanvasItems = <T extends CanvasItemRef>(
    prevData: T[],
    droppedId: string,
    droppedItem: T | undefined,
    getCanvasItemById: (id: string) => T | undefined,
    resolutionDeadlineId: string,
    resolutionExpiryActionId: string,
): T[] => {
    if (!droppedItem) {
        return prevData;
    }

    const newData = [...prevData, droppedItem];

    if (shouldAutoAddResolutionDeadline(droppedId, prevData, resolutionDeadlineId, resolutionExpiryActionId)) {
        const deadlineItem = getCanvasItemById(resolutionDeadlineId);
        if (deadlineItem) {
            newData.push(deadlineItem);
        }
    }

    return newData;
};

export const getDefaultResolutionDeadlineValue = (): Record<string, string> => ({
    deadlineTime: '3',
    deadlineUnit: 'days',
});

export const extractMessageTitle = (value: unknown): string | undefined => {
    if (typeof value !== 'string') {
        return undefined;
    }
    return value;
};

export const isMessageTitleValid = (messageTitle?: string): boolean => {
    if (!messageTitle) {
        return true;
    }
    return !!messageTitle.trim();
};

type SaveSuccessHandlerParams = {
    getValue: () => Record<string, Record<string, unknown>>;
    setInitialValue: (value: Record<string, Record<string, unknown>>) => void;
    addToast: (toast: Omit<ToastType, 'id'>) => void;
    message: string;
};

export const buildSaveSuccessHandler = ({
    getValue,
    setInitialValue,
    addToast,
    message,
}: SaveSuccessHandlerParams): (() => void) => () => {
    setInitialValue(_.cloneDeep(getValue()));
    addToast({
        severity: 'success',
        body: message,
    });
};
